import { Middleware } from '@nuxt/types'
import { createNuxtMiddleware } from '@alao-frontend/utils'

const routeTransformation: Middleware = ctx => createNuxtMiddleware(ctx, () => {
  const { route, redirect } = ctx
  const nextRoute = { ...route }

  // Transform route path to lowercase to avoid case sensitivity issues
  if (route.path !== route.path.toLowerCase()) {
    nextRoute.path = route.path.toLowerCase()
  }

  // Handle trailing slashes in route paths
  if (!route.path.endsWith('/')) {
    nextRoute.path = route.path.concat('/')
  }

  // Redirect if the transformed route is different from the current route
  if (nextRoute.path !== route.path || nextRoute.query !== route.query || nextRoute.hash !== route.hash) {
    redirect(301, {
      path: nextRoute.path,
      query: nextRoute.query,
      hash: nextRoute.hash,
    })
  }
})

export default routeTransformation
